import "./heading.css"; // Import the CSS file
import { Button, Typography } from "antd";
import { isSupplierRole } from "../Shared/utils";

type HeadingButton = {
  key: string;
  label: string;
  onClick: () => void;
  type?: "primary" | "default";
  loading?: boolean;
  disabled?: boolean;
  id?: string;
};
interface HeadingProps {
  title?: string;
  buttonName?: string;
  onClickNavigate?: () => void;
  btnLoading?: boolean;
  buttons?: HeadingButton[];
  userDetails?: any;
  id?: string;
  currentPage?: string;
  handleEditContact?: () => void;
  hideCancelButton?: boolean;
}

const Heading = ({
  title,
  buttonName,
  onClickNavigate,
  btnLoading,
  userDetails,
  id,
  currentPage,
  handleEditContact,
  buttons,
  hideCancelButton,
}: HeadingProps) => {
  const btnHiddenPages = [
    "data-transfer",
    "data-upload",
    "review",
    "preview-page",
    "edit-contact",
    "finalize-transfer",
    "reject-transfer",
    "initiate-transfer"
  ];

  const isTransferDetailsEnable =
    currentPage !== "data-transfer" &&
    currentPage !== "preview-page" &&
    currentPage !== "initiate-transfer" &&
    currentPage !== "edit-contact" &&
    userDetails;

  return (
    <div className="data-heading-container">
      <div className="data-heading-left">
        <h4>{title}</h4>
        {isTransferDetailsEnable && (
          <div>
            <div>MSD Compound/Protocol: {userDetails?.msd}</div>
            <div>
              DTS version: {parseFloat(userDetails?.dts_version).toFixed(1)}
            </div>
            <div>Transfer ID: {userDetails?.transfer_id}</div>
          </div>
        )}
      </div>
      <div className="data-transfer-right">
        {isTransferDetailsEnable && (
          <div>
            <div>Supplier: {userDetails?.supplier_org}</div>
            <div>
              Supplier compound/protocol: {userDetails?.supplier_compound}
            </div>
            {(currentPage === "data-upload" ||
              currentPage === "review" ||
              currentPage === "finalize-transfer" ||
              currentPage === "reject-transfer") &&
              !isSupplierRole() && (
                <div style={{ marginTop: 15 }}>
                  <Typography
                    onClick={handleEditContact}
                    style={{ color: "#1890ff", cursor: "pointer" }}
                  >
                    Edit Contacts
                  </Typography>
                </div>
              )}
          </div>
        )}
      </div>
      <div className="data-heading-right">
        {
          buttons?.map((button) => (
            <Button
              key={button.key}
              id={button.id}
              type={button.type ?? (userDetails ? "default" : "primary")}
              onClick={button.onClick}
              loading={button.loading}
              disabled={button.disabled}
              className="data-heading-btn"
              iconPosition="end"
            >
              {button.label}
            </Button>
          ))
        }
        {
          // If hideCancelButton is true, always hide the button regardless of any other condition
          !hideCancelButton &&
          // show btn only for dashboard page (currentPage = undefined) or pages outside btnHiddenPages
          (currentPage === undefined || !btnHiddenPages.includes(currentPage)) &&
          !(
            (currentPage === "supplier-signature" || currentPage === "requester-signature") &&
            isSupplierRole()
          ) &&
          buttonName && (
            <Button
              type={userDetails ? "default" : "primary"}
              onClick={onClickNavigate}
              className="data-heading-btn"
              loading={btnLoading}
              iconPosition="end"
            >
              {buttonName}
            </Button>
          )
        }
      </div>
    </div>
  );
};

export default Heading;
